import React, { useEffect, useState } from "react";
import "./instructions.scss";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import clintlogo from "../../assets/images/default_avtar.png";
import EnglishInstruction from "../instructions/english";
import HindiInstraction from "./hindi";
import KanndaInstraction from "./kannda";
import FrenchInstruction from "./french";
import GermanInstruction from "./german";
import api from "../../api";
import Loader from "../loader";
import el_user from "../../assets/icons/el_user.svg";
import { setLanguageByInstitute } from "../../translation/i18";
// import { FullScreen, useFullScreenHandle } from "react-full-screen";
const Instractions = (props) => {
  const { t, i18n } = useTranslation();
  let languageJSON = [
    {
      id: 1,
      title: "Hindi",
    },
    {
      id: 2,
      title: "English",
    },
    {
      id: 3,
      title: "French",
    },
    {
      id: 4,
      title: "German",
    },
    {
      id: 5,
      title: "Kannada",
    },
  ];
  const [multiLanguageslist, setMultiLanguageslist] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState();
  const [language, setLanguage] = useState(() => {
    // Language will be set based on institute ID
    // Default to English
    return "English";
  });
    const [startingBtnText, setStartingBtnText] = useState(t("common.startTest"));
  const [testEnabled, setTestEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [accept_terms, SetAccept_terms] = useState(false);
  const [serverTimeStamp, setServerTimeStamp] = useState(0);
  const [leftHours, setLeftHours] = useState("");
  const [leftDays, setLeftDays] = useState("");
  const [leftMins, setLeftMins] = useState("");
  const [leftSecs, setLeftSecs] = useState("");
  // const handle = useFullScreenHandle();

  
  useEffect(() => {
    if (
      props.state.test_data == undefined ||
      props.state.student_data == undefined
    ) {
      window.location.replace("/");
    } else {
      if (props.state.test_data.is_multi_lingual === 1) {
        // Show all 5 languages in dropdown: Hindi, English, French, German, Kannada
        const allLanguages = [
          { id: 1, title: "Hindi" },
          { id: 2, title: "English" },
          { id: 3, title: "French" },
          { id: 4, title: "German" },
          { id: 5, title: "Kannada" }
        ];

        setMultiLanguageslist(allLanguages);
      }
  
      // Start button logic (unchanged)
      if (props.state.student_data.userid !== 1234567890) {
        if (props.state.test_data.test_type_id === 2) {
          if (
            props.state.attempt_data &&
            props.state.attempt_data.attempt_count > 0
          ) {
            setStartingBtnText(t("common.restartTest"));
          } else if (props.state.attempt_data.attempt_data !== null) {
            setStartingBtnText(t("common.resumeTest"));
          } else {
            setStartingBtnText(t("common.startTest"));
          }
        } else {
          if (props.state.attempt_data.attempt_data == null) {
            setStartingBtnText(t("common.startTest"));
          } else {
            setStartingBtnText(t("common.resumeTest"));
          }
        }
      } else {
        setStartingBtnText(t("common.startTest"));
      }
  
      initTimer();
    }
  }, []);

  // Effect to set language based on institute ID
  useEffect(() => {
    if (props.state?.institute_data?.institute_id) {
      const instituteId = props.state.institute_data.institute_id;
      console.log("Instructions: Setting language for institute ID:", instituteId);
      const langCode = setLanguageByInstitute(instituteId);

      // Set the language display name based on the language code
      const langName = langCode === "fr" ? "French" : "English";
      setLanguage(langName);
    }
  }, [props.state?.institute_data]);
  
  
  const changeByLanguage = (langTitle) => {
    setLanguage(langTitle);

    // Change i18n language based on selected language
    const langCode = langTitle.toLowerCase() === "english" ? "en" :
                     langTitle.toLowerCase() === "hindi" ? "hi" :
                     langTitle.toLowerCase() === "french" ? "fr" :
                     langTitle.toLowerCase() === "german" ? "de" :
                     langTitle.toLowerCase() === "kannada" ? "kn" : "fr";

    i18n.changeLanguage(langCode);

    // Match language object from your static language list
    const selectedLangObj = languageJSON.find(l => l.title === langTitle);

    if (selectedLangObj) {
      // Save numeric ID in localStorage
      localStorage.setItem("preferred_language", selectedLangObj.id);

      // Dispatch correct ID to Redux
      props.dispatch({
        type: "CHANGES_LANGUAGE",
        languageSelected: selectedLangObj.id,
      });

      // Update button text based on current state
      if (props.state.test_data.test_type_id === 2) {
        if (props.state.attempt_data && props.state.attempt_data.attempt_count > 0) {
          setStartingBtnText(t("common.restartTest"));
        } else if (props.state.attempt_data.attempt_data !== null) {
          setStartingBtnText(t("common.resumeTest"));
        } else {
          setStartingBtnText(t("common.startTest"));
        }
      } else {
        if (props.state.attempt_data.attempt_data == null) {
          setStartingBtnText(t("common.startTest"));
        } else {
          setStartingBtnText(t("common.resumeTest"));
        }
      }
    }
  };
  
  
  
  

  const initTimer = async () => {
    let SrvrTimeStamp = 0;
    setLoading(true);
    let request = {
      url: `/v1/examPanel/time`,
      headers: {
        "X-Device-Info":
          "eyJkZXZpY2UiOiJVbmtub3duIiwiYnJvd3NlciI6IkNocm9tZSA5OS4wLjQ4NDQuODIiLCJvcyI6IldpbmRvd3Mgd2luZG93cy0xMCJ9",
        "X-Device-Key": "ozfinggcn7",
      },
    };
    await api.getAuthTZ(request).then(
      (response) => {
        setLoading(false);
        setServerTimeStamp(response.data.timestamp);
        SrvrTimeStamp = response.data.timestamp;
        sessionStorage.setItem("exam-date", serverTimeStamp);
      },
      (errors) => {
        setLoading(false);
      }
    );
    const x = setInterval(function () {
      SrvrTimeStamp = SrvrTimeStamp + 1;
      let distance = props.state.test_data.test_start_timestamp - SrvrTimeStamp;
      let formattedLeftTimeToStart =
        Math.floor(distance / 3600) +
        " : " +
        ("0" + (Math.floor(distance / 60) % 60)).slice(-2) +
        " : " +
        ("0" + (distance % 60)).slice(-2);
      let leftHours = Math.floor(distance / 3600);
      let leftDays = Math.floor(leftHours / 24);
      let leftMins = ("0" + (Math.floor(distance / 60) % 60)).slice(-2);
      let leftSecs = ("0" + (distance % 60)).slice(-2);

      setLeftDays(leftDays);
      setLeftHours(leftHours);
      setLeftMins(leftMins);
      setLeftSecs(leftSecs);
      if (distance <= 0) {
        clearInterval(x);
        setTestEnabled(true);
      }
    }, 1000);
  };

  const renderDescription = (description) => {
    const lines = description.split('\r\n');
    let isOrderedList = false; 
    let orderedListItems = [];

    return lines.map((line, index) => {
      const boldMatch = line.match(/\*\*(.*?)\*\*/);
    if (boldMatch) {
      line = line.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
    }

    const headingMatch = line.match(/^(#{1,6})\s*(.*?)$/);  
    if (headingMatch) {
      const level = headingMatch[1].length;
      line = `<h${level}>${headingMatch[2]}</h${level}>`;
    }

    const codeBlockMatch = line.match(/^```([\s\S]*?)```$/); 
    if (codeBlockMatch) {
      line = `<pre><code>${codeBlockMatch[1]}</code></pre>`;
    }

    const italicsMatch = line.match(/:_([^:]+):_/); 
    if (italicsMatch) {
      line = line.replace(/:_([^:]+):_/g, "<em>$1</em>");
    }

    const orderedListMatch = line.match(/^(\d+)\.\s+(.*)$/);
    if (orderedListMatch) {
      if (!isOrderedList) {
        isOrderedList = true;
        orderedListItems.push(`<ol><li>${orderedListMatch[2]}</li>`);
      } else {
        orderedListItems.push(`<li>${orderedListMatch[2]}</li>`);
      }
    } else {
      if (isOrderedList) {
        orderedListItems.push('</ol>');
        isOrderedList = false;
      }
    }

    if (!orderedListMatch) {
      if (isOrderedList) {
        return orderedListItems.join('');
      }
    }

      // const imageMatch = line.match(/!\[([^\]]*)\]\((https?:\/\/[^\)]+)\s*"(.*?)"\)/)                            
      // if (imageMatch) {
      //   return <img key={index} src={imageMatch[2]} alt={imageMatch[1]} title={imageMatch[3]} style={{ width: "100%", height: "auto" }} />;
      // }
    //   const imageMatch = line.match(/!\[([^\]]*)\]\((https?:\/\/[^\s\)]+)(?:\s+"([^"]+)")?\)/);
    // if (imageMatch) {
    //   // Replace with an HTML <img> tag
    //   line = line.replace(/!\[([^\]]*)\]\((https?:\/\/[^\s\)]+)(?:\s+"([^"]+)")?\)/g, (match, alt, url, title) => {
    //     return `<img src="${url}" alt="${alt}" ${title ? `title="${title}"` : ""} style={{ width: "100%", height: "auto" }}/>`;
    //   });
    // }
    line = line.replace(/!\[([^\]]*)\]\((https?:\/\/[^\s\)]+)(?:\s+"([^"]+)")?\)/g, (match, alt, url, title) => {
      return `<img src="${url}" alt="${alt}" style="width: 100%; height: auto;" ${title ? `title="${title}"` : ""} />`;
    });

    // Match and replace links
    line = line.replace(/\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g, (match, text, url) => {
      return `<a href="${url}" target="_blank" style="width: 100%; height: auto;" rel="noopener noreferrer">${text}</a>`;
    });
      const linkMatch = line.match(/\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/);
    if (linkMatch) {
      line = line.replace(/\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g, `<a href="$2" target="_blank" rel="noopener noreferrer">${linkMatch[1]}</a>`);
    }
      return <div key={index} dangerouslySetInnerHTML={{ __html: line }} />;
    });
  };

  return (
    <>
      {loading && (
        <div>
          <Loader />
        </div>
      )}

      <div class="s1-v">
        <div class="header">
          <div>
            <a href="#">
              <button>{t("common.onlineTest")}</button>
            </a>
          </div>
          <p>
            {props.state.institute_data.account_name !== ""
              ? props.state.institute_data.account_name
              : props.state.client_name}
          </p>
          {props.state.student_data.userid == 1234567890 &&
            !props.state.registrationdata && (
              <a>
                <button>{t("common.testPreview")}</button>
              </a>
            )}
        </div>
        <div class="height">
          <div class="h1-gg">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItem: "center",
                height: "35px",
                marginBottom: "5px",
                borderBottom: "1px solid #ddd",
              }}
            >
              <p
                className="instructionTitle"
                style={{ marginBottom: "20px", marginTop: "10px" }}
              >
{t("instructions.title")}
              </p>
              {props.state.test_data.is_multi_lingual == 1 &&
                multiLanguageslist.length && (
                  <span className="float-right" style={{ marginTop: "4px" }}>
                    <select
  name="language-select"
  className="custom-form-input"
  value={language}
  onChange={(event) => changeByLanguage(event.target.value)}
>
  {multiLanguageslist.map((lang) => (
    <option key={lang.title} value={lang.title}>
      {lang.title}
    </option>
  ))}
</select>

                  </span>
                )}
            </div>
            <div>
              <div style={{ height: "90%" }}>
                {console.log("language",language)}
                {language === "English" && (
                  <EnglishInstruction
                    instruction={
                      props.state.test_data.instruction_content == null
                        ? atob(
                            props.state.test_data.instruction_description
                          ).replace(/(<([^>]+)>)/gi, "")
                        :
                        renderDescription(props.state.test_data.instruction_content[0]?.description || "")
                    }
                  />
                )}
                {language === "Hindi" && (
                  <HindiInstraction
                    instruction={
                      props.state.test_data.instruction_content == null
                        ? atob(
                            props.state.test_data.instruction_description
                          ).replace(/(<([^>]+)>)/gi, "")
                        :
                        renderDescription(props.state.test_data.instruction_content[0]?.description || "")
                    }
                  />
                )}
                {language === "French" && (
                  <FrenchInstruction
                    instruction={
                      props.state.test_data.instruction_content == null
                        ? atob(
                            props.state.test_data.instruction_description
                          ).replace(/(<([^>]+)>)/gi, "")
                        :
                        renderDescription(props.state.test_data.instruction_content[0]?.description || "")
                    }
                  />
                )}
                {language === "German" && (
                  <GermanInstruction
                    instruction={
                      props.state.test_data.instruction_content == null
                        ? atob(
                            props.state.test_data.instruction_description
                          ).replace(/(<([^>]+)>)/gi, "")
                        :
                        renderDescription(props.state.test_data.instruction_content[0]?.description || "")
                    }
                  />
                )}
                {language === "Kannada" && (
                  <KanndaInstraction
                    instruction={
                      props.state.test_data.instruction_content == null
                        ? atob(
                            props.state.test_data.instruction_description
                          ).replace(/(<([^>]+)>)/gi, "")
                        :
                        renderDescription(props.state.test_data.instruction_content[0]?.description || "")
                    }
                  />
                )}
                {props.state.test_data.is_multi_lingual == 1 &&
                  multiLanguageslist.length && (
                    <div>
                        <div className="text-danger">
                          {t("instructions.multiLanguageNote")}
                        </div>
                    </div>
                  )}
              </div>
            </div>
            {testEnabled == true && (
              <label
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "baseline",
                }}
              >
                <input
                  type="checkbox"
                  id="en_ch"
                  onChange={(event) =>
                    event.target.checked == true
                      ? SetAccept_terms(true)
                      : SetAccept_terms(false)
                  }
                />
                <span
                  className="confirmationText"
                  style={{
                    marginLeft: "5px",
                    opacity: accept_terms ? "1.0" : "0.5",
                  }}
                >
                  {t("instructions.confirmation")}
                </span>
              </label>
            )}
            {testEnabled == false && (
              <div className="row col-md-12 text-center countdown-clock">
                <p className="label">{t("common.examStartsIn")}</p>
                <div className="d-block timer" style={{ width: "100%" }}>
                  <div className="d-inline-block clock-pallet">
                    <p className="left-day left-time-value">{leftDays}</p>
                    <p className="left-time-label">{t("common.days")}</p>
                  </div>
                  <div className="d-inline-block clock-pallet">
                    <p className="left-hours left-time-value">{leftHours}</p>
                    <p className="left-time-label">{t("common.hours")}</p>
                  </div>
                  <div className="d-inline-block clock-pallet">
                    <p className="left-minutes left-time-value">{leftMins}</p>
                    <p className="left-time-label">{t("common.minutes")}</p>
                  </div>
                  <div className="d-inline-block clock-pallet">
                    <p className="left-seconds left-time-value">{leftSecs}</p>
                    <p className="left-time-label">{t("common.seconds")}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div class="name_details">
            <img src={el_user} />
            <div class="br"></div>
            <p>{t("common.signedInAs")}</p>

            {props.state.student_data.userid == 1234567890 ? (
              <span>{props.state.registrationdata?.name ?? "User"}</span>
            ) : (
              <span>{props.state.student_data.name}</span>
            )}
            <div class="br"></div>
            {/* <p>Mobile Number</p>
          {props.state.student_data.userid == 1234567890 ? <span>{props.state.registrationdata?.number ?? "1234567890"}</span> : <span>{props.state.student_data.phone}</span>} */}
          </div>
        </div>

        <button
          style={{ opacity: accept_terms ? "1.0" : "0.5" }}
          onClick={() => window.location.replace("/panel")}
          disabled={!accept_terms}
        >
          {startingBtnText}
        </button>
      </div>

      {/* </FullScreen> */}
    </>
  );
};
const mapStateToProps = (state) => ({ state: state });
export default connect(mapStateToProps)(Instractions);
